import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import UseCasesSection from './components/UseCasesSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { companyInfo } from '@/mocks/navigation';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: companyInfo.name,
            url: 'https://hteoapeks.cn',
            description: companyInfo.slogan,
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://hteoapeks.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: companyInfo.name,
            url: 'https://hteoapeks.cn',
            description: companyInfo.slogan,
            email: companyInfo.email,
            telephone: companyInfo.phone,
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressRegion: '北京',
              addressCountry: 'CN',
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <FeaturesSection />
          <UseCasesSection />
          <StatsSection />
          <TestimonialsSection />
          <FAQSection />
          <CTASection />
        </article>
      </main>
      <Footer />
    </>
  );
}